import { useEffect, useRef } from 'react';
import Lenis from 'lenis';
import { useModal } from '../App';

const SmoothScroll = () => {
  const lenisRef = useRef(null);
  const { activeModal } = useModal();

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      prevent: (node) => {
        let el = node;
        while (el && el !== document.body) {
          if (
            el.hasAttribute('data-lenis-prevent') ||
            el.classList.contains('overflow-y-auto') ||
            el.classList.contains('overflow-y-scroll')
          ) {
            return true;
          }
          el = el.parentElement;
        }
        return false;
      },
    });

    lenisRef.current = lenis;

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
      lenisRef.current = null;
    };
  }, []);

  // Stop Lenis background scroll when any modal is open
  useEffect(() => {
    const lenis = lenisRef.current;
    if (!lenis) return;
    if (activeModal) {
      lenis.stop();
    } else {
      lenis.start();
    }
  }, [activeModal]);

  return null;
};

export default SmoothScroll;
